import React, { useState, useEffect, useMemo } from 'react';
import { Activity, Users, TrendingUp, TrendingDown, Minus, FileText, Pencil } from 'lucide-react';
import { getPlayers, getGPS, getScenarios, getRPE, updateSessionNotes, getLoadScenarios } from '../api';
import EstimateModal from './gps/EstimateModal';
import { useSeason, dateToSeason } from '../SeasonContext';
import { rpeValueColor, rpeAssessment } from './WellnessInput';
import { useUrlParam } from '../hooks/useUrlParam';

// Mirrored at project root in targets.js for the Team Overview "missed targets"
// aggregation (server-side, CommonJS) — keep both in sync if this table changes.
const TARGETS_RAW = `Scenario\tdaylabel\tpos\tTD Upper\tTD Lower\tRD Upper\tRD Lower\tHID Upper\tHID Lower\tSD Upper\tSD Lower\tSA Upper\tSA Lower\tExpl Upper\tExpl Lower\tHMLD Upper\tHMLD Lower
1A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD+4\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD-1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
1B\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1B\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1B\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1B\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1B\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1B\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1B\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD+3\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
1B\tMD+3\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
1B\tMD+3\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
1B\tMD+3\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
1B\tMD+3\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
1B\tMD+3\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
1B\tMD+4\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1B\tMD+4\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1B\tMD+4\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1B\tMD+4\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1B\tMD+4\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1B\tMD+4\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1B\tMD-3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1B\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
1B\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
1B\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
1B\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
1B\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
1B\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
1B\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
1B\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
1B\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
1B\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
1B\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
1B\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
1B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
1C\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
1C\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
1C\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
1C\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
1C\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
1C\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
1C\tMD+3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1C\tMD+3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1C\tMD+3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1C\tMD+3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1C\tMD+3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1C\tMD+3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1C\tMD+4\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD+4\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1C\tMD-3\tCB\t5524\t4564\t632\t484\t174\t119\t37\t14\t87\t72\t564\t403\t738\t523
1C\tMD-3\tFB\t5777\t4772\t611\t467\t303\t208\t77\t29\t111\t92\t720\t514\t1023\t722
1C\tMD-3\tCDM\t6344\t5241\t749\t573\t243\t167\t38\t14\t105\t87\t679\t485\t922\t652
1C\tMD-3\tCAM\t6103\t5042\t844\t645\t234\t161\t36\t13\t105\t87\t679\t485\t913\t646
1C\tMD-3\tST\t5554\t4588\t674\t515\t275\t189\t60\t22\t96\t79\t618\t442\t893\t630
1C\tMD-3\tW\t5711\t4717\t618\t472\t301\t207\t65\t24\t111\t92\t720\t514\t1020\t721
1C\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
1C\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
1C\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
1C\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
1C\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
1C\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
1C\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
1C\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
1C\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
1C\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
1C\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
1C\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
1C\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1C\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1C\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1C\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1C\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1C\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
1D\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1D\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1D\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1D\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1D\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1D\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1D\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD+3\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
1D\tMD+3\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
1D\tMD+3\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
1D\tMD+3\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
1D\tMD+3\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
1D\tMD+3\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
1D\tMD+4\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1D\tMD+4\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1D\tMD+4\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1D\tMD+4\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1D\tMD+4\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1D\tMD+4\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1D\tMD-4\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-4\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
1D\tMD-3\tCB\t5524\t4564\t632\t484\t174\t119\t37\t14\t87\t72\t564\t403\t738\t523
1D\tMD-3\tFB\t5777\t4772\t611\t467\t303\t208\t77\t29\t111\t92\t720\t514\t1023\t722
1D\tMD-3\tCDM\t6344\t5241\t749\t573\t243\t167\t38\t14\t105\t87\t679\t485\t922\t652
1D\tMD-3\tCAM\t6103\t5042\t844\t645\t234\t161\t36\t13\t105\t87\t679\t485\t913\t646
1D\tMD-3\tST\t5554\t4588\t674\t515\t275\t189\t60\t22\t96\t79\t618\t442\t893\t630
1D\tMD-3\tW\t5711\t4717\t618\t472\t301\t207\t65\t24\t111\t92\t720\t514\t1020\t721
1D\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
1D\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
1D\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
1D\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
1D\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
1D\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
1D\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
1D\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
1D\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
1D\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
1D\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
1D\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
1D\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1D\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1D\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1D\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1D\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1D\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
1E\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1E\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1E\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1E\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1E\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1E\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1E\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
1E\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
1E\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
1E\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
1E\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
1E\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
1E\tMD+3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
1E\tMD+3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
1E\tMD+3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
1E\tMD+3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
1E\tMD+3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
1E\tMD+3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
1E\tMD-2\tCB\t5524\t4564\t632\t484\t174\t119\t37\t14\t87\t72\t564\t403\t738\t523
1E\tMD-2\tFB\t5777\t4772\t611\t467\t303\t208\t77\t29\t111\t92\t720\t514\t1023\t722
1E\tMD-2\tCDM\t6344\t5241\t749\t573\t243\t167\t38\t14\t105\t87\t679\t485\t922\t652
1E\tMD-2\tCAM\t6103\t5042\t844\t645\t234\t161\t36\t13\t105\t87\t679\t485\t913\t646
1E\tMD-2\tST\t5554\t4588\t674\t515\t275\t189\t60\t22\t96\t79\t618\t442\t893\t630
1E\tMD-2\tW\t5711\t4717\t618\t472\t301\t207\t65\t24\t111\t92\t720\t514\t1020\t721
1E\tMD-1\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
1E\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
1E\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
1E\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
1E\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
1E\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
1E\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
1E\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
1E\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
1E\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
1E\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
1E\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
2A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
2A\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
2A\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
2A\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
2A\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
2A\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
2A\tMD+3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
2A\tMD+3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
2A\tMD+3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
2A\tMD+3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
2A\tMD+3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
2A\tMD+3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
2A\tMD-3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2A\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
2A\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
2A\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
2A\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
2A\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
2A\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
2A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
2A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
2A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
2A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
2A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
2A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
2A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
2A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
2A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
2A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
2A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
2A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
2B\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
2B\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
2B\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
2B\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
2B\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
2B\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
2B\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2B\tMD+3\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
2B\tMD+3\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
2B\tMD+3\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
2B\tMD+3\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
2B\tMD+3\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
2B\tMD+3\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
2B\tMD-3\tCB\t7304\t6034\t1613\t1233\t429\t295\t87\t32\t126\t104\t816\t583\t1465\t1033
2B\tMD-3\tFB\t7638\t6310\t1557\t1191\t749\t515\t183\t68\t161\t133\t1040\t743\t2105\t1480
2B\tMD-3\tCDM\t8388\t6929\t1910\t1460\t601\t413\t90\t33\t152\t125\t982\t701\t1862\t1311
2B\tMD-3\tCAM\t8069\t6666\t2152\t1646\t578\t397\t85\t32\t152\t125\t982\t701\t1835\t1293
2B\tMD-3\tST\t7344\t6067\t1718\t1314\t679\t467\t143\t53\t138\t114\t894\t638\t1850\t1300
2B\tMD-3\tW\t4845\t4003\t1575\t1204\t743\t511\t154\t57\t161\t133\t1040\t743\t2099\t1476
2B\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
2B\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
2B\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
2B\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
2B\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
2B\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
2B\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
2B\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
2B\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
2B\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
2B\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
2B\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
2B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
2B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
2B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
2B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
2B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
2B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
2C\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
2C\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
2C\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
2C\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
2C\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
2C\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
2C\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
2C\tMD-3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
2C\tMD-3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
2C\tMD-3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
2C\tMD-3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
2C\tMD-3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
2C\tMD-3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
2C\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
2C\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
2C\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
2C\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
2C\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
2C\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
2C\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
2C\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
2C\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
2C\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
2C\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
2C\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
2C\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
2C\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
2C\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
2C\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
2C\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
2C\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
3A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3A\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
3A\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
3A\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
3A\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
3A\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
3A\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
3A\tMD+3\tCB\t7304\t6034\t1613\t1233\t429\t295\t87\t32\t126\t104\t816\t583\t1465\t1033
3A\tMD+3\tFB\t7638\t6310\t1557\t1191\t749\t515\t183\t68\t161\t133\t1040\t743\t2105\t1480
3A\tMD+3\tCDM\t8388\t6929\t1910\t1460\t601\t413\t90\t33\t152\t125\t982\t701\t1862\t1311
3A\tMD+3\tCAM\t8069\t6666\t2152\t1646\t578\t397\t85\t32\t152\t125\t982\t701\t1835\t1293
3A\tMD+3\tST\t7344\t6067\t1718\t1314\t679\t467\t143\t53\t138\t114\t894\t638\t1850\t1300
3A\tMD+3\tW\t4845\t4003\t1575\t1204\t743\t511\t154\t57\t161\t133\t1040\t743\t2099\t1476
3A\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
3A\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
3A\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
3A\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
3A\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
3A\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
3A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
3A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
3A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
3A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
3A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
3A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
3A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
3A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
3A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
3A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
3A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
3A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
3B\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
3B\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
3B\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
3B\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
3B\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
3B\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
3B\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3B\tMD+3\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
3B\tMD+3\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
3B\tMD+3\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
3B\tMD+3\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
3B\tMD+3\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
3B\tMD+3\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
3B\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
3B\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
3B\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
3B\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
3B\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
3B\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
3B\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
3B\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
3B\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
3B\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
3B\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
3B\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
3B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
3B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
3B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
3B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
3B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
3B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
3C\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
3C\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
3C\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
3C\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
3C\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
3C\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
3C\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
3C\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
3C\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
3C\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
3C\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
3C\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
3C\tMD+3\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD+3\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3C\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
3C\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
3C\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
3C\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
3C\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
3C\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
3C\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
3C\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
3C\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
3C\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
3C\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
3C\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
3C\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
3C\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
3C\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
3C\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
3C\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
3C\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
3D\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
3D\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
3D\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
3D\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
3D\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
3D\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
3D\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
3D\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
3D\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
3D\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
3D\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
3D\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
3D\tMD+3\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
3D\tMD+3\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
3D\tMD+3\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
3D\tMD+3\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
3D\tMD+3\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
3D\tMD+3\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
3D\tMD-2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
3D\tMD-1\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
3D\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
3D\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
3D\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
3D\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
3D\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
3D\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
3D\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
3D\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
3D\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
3D\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
3D\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
4A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4A\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
4A\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
4A\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
4A\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
4A\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
4A\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
4A\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
4A\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
4A\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
4A\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
4A\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
4A\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
4A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
4A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
4A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
4A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
4A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
4A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
4A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
4A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
4A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
4A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
4A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
4A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
4B\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4B\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t650\t462
4B\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t868\t616
4B\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t798\t567
4B\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t679\t485\t794\t564
4B\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t753\t534
4B\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t867\t616
4B\tMD+3\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
4B\tMD+3\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
4B\tMD+3\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
4B\tMD+3\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
4B\tMD+3\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
4B\tMD+3\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
4B\tMD+4\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
4B\tMD+4\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
4B\tMD+4\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
4B\tMD+4\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
4B\tMD+4\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
4B\tMD+4\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
4B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
4B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
4B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
4B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
4B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
4B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
4C\tMD+1\tCB\t8593\t7099\t1897\t1451\t505\t347\t103\t38\t148\t123\t960\t685\t1465\t1033
4C\tMD+1\tFB\t8986\t7423\t1832\t1401\t881\t605\t215\t80\t189\t156\t1224\t874\t2105\t1480
4C\tMD+1\tCDM\t9868\t8152\t2247\t1718\t707\t486\t106\t39\t179\t148\t1155\t825\t1862\t1311
4C\tMD+1\tCAM\t9493\t7842\t2532\t1936\t680\t468\t101\t37\t179\t148\t1155\t825\t1835\t1293
4C\tMD+1\tST\t8640\t7137\t2021\t1546\t799\t549\t169\t62\t163\t134\t1052\t751\t1850\t1300
4C\tMD+1\tW\t8883\t7338\t1853\t1417\t875\t601\t181\t67\t189\t156\t1224\t874\t2099\t1476
4C\tMD+2\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD+2\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
4C\tMD-2\tCB\t5524\t4564\t632\t484\t174\t119\t37\t14\t87\t72\t564\t403\t738\t523
4C\tMD-2\tFB\t5777\t4772\t611\t467\t303\t208\t77\t29\t111\t92\t720\t514\t1023\t722
4C\tMD-2\tCDM\t6344\t5241\t749\t573\t243\t167\t38\t14\t105\t87\t679\t485\t922\t652
4C\tMD-2\tCAM\t6103\t5042\t844\t645\t234\t161\t36\t13\t105\t87\t679\t485\t913\t646
4C\tMD-2\tST\t5554\t4588\t674\t515\t275\t189\t60\t22\t96\t79\t618\t442\t893\t630
4C\tMD-2\tW\t5711\t4717\t618\t472\t301\t207\t65\t24\t111\t92\t720\t514\t1020\t721
4C\tMD-1\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
4C\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
4C\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
4C\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
4C\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
4C\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
4C\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
4C\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
4C\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
4C\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
4C\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
4C\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
5A\tMD+1\tCB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tFB\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tCDM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tCAM\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tST\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+1\tW\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0\t0
5A\tMD+2\tCB\t4687\t3872\t548\t419\t85\t59\t7\t3\t87\t72\t564\t403\t652\t475
5A\tMD+2\tFB\t4902\t4049\t529\t405\t149\t102\t15\t6\t111\t92\t720\t514\t831\t606
5A\tMD+2\tCDM\t5383\t4447\t649\t496\t119\t82\t8\t3\t105\t87\t679\t485\t784\t572
5A\tMD+2\tCAM\t5178\t4278\t732\t559\t115\t79\t7\t3\t105\t87\t618\t442\t724\t529
5A\tMD+2\tST\t4713\t3893\t584\t446\t135\t93\t12\t4\t96\t79\t618\t442\t714\t521
5A\tMD+2\tW\t4845\t4003\t535\t409\t148\t101\t13\t5\t111\t92\t720\t514\t831\t606
5A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
5A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
5A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
5A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
5A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
5A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
5A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
5A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
5A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
5A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
5A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
5A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
6A\tMD-2\tCB\t6361\t5255\t717\t548\t284\t195\t66\t24\t87\t72\t564\t403\t849\t598
6A\tMD-2\tFB\t6652\t5495\t692\t529\t495\t341\t139\t51\t111\t92\t720\t514\t1215\t855
6A\tMD-2\tCDM\t7305\t6035\t849\t649\t397\t273\t68\t25\t105\t87\t679\t485\t1077\t758
6A\tMD-2\tCAM\t7028\t5805\t957\t732\t383\t263\t65\t24\t105\t87\t679\t485\t1062\t748
6A\tMD-2\tST\t6396\t5284\t764\t584\t449\t309\t108\t40\t96\t79\t618\t442\t1068\t751
6A\tMD-2\tW\t6576\t5432\t700\t535\t492\t338\t116\t43\t111\t92\t720\t514\t1212\t852
6A\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
6A\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
6A\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
6A\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
6A\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
6A\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
6A\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
6A\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
6A\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
6A\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
6A\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
6A\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535
6B\tMD+1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t118\t97\t564\t403\t612\t436
6B\tMD+1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t150\t124\t720\t514\t802\t571
6B\tMD+1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t142\t117\t679\t485\t746\t531
6B\tMD+1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t142\t117\t679\t485\t743\t529
6B\tMD+1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t129\t107\t618\t442\t693\t493
6B\tMD+1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t150\t124\t720\t514\t802\t571
6B\tMD-1\tCB\t4464\t3688\t590\t451\t47\t33\t22\t8\t79\t65\t510\t364\t557\t397
6B\tMD-1\tFB\t4668\t3856\t570\t436\t83\t57\t46\t17\t100\t83\t650\t464\t733\t521
6B\tMD-1\tCDM\t5126\t4235\t699\t535\t66\t46\t23\t8\t95\t78\t613\t438\t680\t484
6B\tMD-1\tCAM\t4932\t4074\t788\t602\t64\t44\t22\t8\t95\t78\t613\t438\t677\t482
6B\tMD-1\tST\t4488\t3708\t629\t481\t75\t51\t36\t13\t86\t71\t558\t399\t633\t450
6B\tMD-1\tW\t4615\t3812\t576\t441\t82\t56\t39\t14\t100\t83\t650\t464\t732\t521
6B\tMD\tCB\t10675\t10675\t2480\t2480\t592\t592\t136\t136\t128\t128\t1184\t1184\t1776\t1776
6B\tMD\tFB\t11163\t11163\t2395\t2395\t1032\t1032\t285\t285\t185\t185\t1510\t1510\t2542\t2542
6B\tMD\tCDM\t12259\t12259\t2937\t2937\t828\t828\t140\t140\t165\t165\t1425\t1425\t2253\t2253
6B\tMD\tCAM\t11793\t11793\t3310\t3310\t797\t797\t133\t133\t167\t167\t1425\t1425\t2222\t2222
6B\tMD\tST\t10733\t10733\t2642\t2642\t936\t936\t223\t223\t157\t157\t1297\t1297\t2233\t2233
6B\tMD\tW\t11035\t11035\t2422\t2422\t1025\t1025\t239\t239\t187\t187\t1510\t1510\t2535\t2535`;
const parseTargets = () => {
  const lines = TARGETS_RAW.trim().split('\n').slice(1);
  const lookup = {};
  lines.forEach(line => {
    const p = line.split('\t');
    const [scenario, daylabel, pos] = p;
    const n = v => parseFloat(String(v).replace(',', '.')) || 0;
    if (!lookup[scenario]) lookup[scenario] = {};
    if (!lookup[scenario][daylabel]) lookup[scenario][daylabel] = {};
    lookup[scenario][daylabel][pos] = {
      TD:   { upper: n(p[3]),  lower: n(p[4])  },
      RD:   { upper: n(p[5]),  lower: n(p[6])  },
      HID:  { upper: n(p[7]),  lower: n(p[8])  },
      SD:   { upper: n(p[9]),  lower: n(p[10]) },
      SA:   { upper: n(p[11]), lower: n(p[12]) },
      Expl: { upper: n(p[13]), lower: n(p[14]) },
      HMLD: { upper: n(p[15]), lower: n(p[16]) },
    };
  });
  return lookup;
};

export const TARGETS = parseTargets();

const GAUGE_METRICS = [
  { key: 'TD',   label: 'Total Distance',      unit: 'm',  category: 'Endurance'     },
  { key: 'RD',   label: 'Run Dist. >14.4km/h', unit: 'm',  category: 'Endurance'     },
  { key: 'HID',  label: 'HID >19.8km/h',       unit: 'm',  category: 'High velocity' },
  { key: 'SD',   label: 'Sprint >25.2km/h',     unit: 'm',  category: 'High velocity' },
  { key: 'SA',   label: 'Short Actions',        unit: '',   category: 'Small spaces'  },
  { key: 'Expl', label: 'Explosive Dist.',      unit: 'm',  category: 'Small spaces'  },
];

export const STATUS_COLORS = { above: '#7c3aed', green: '#10b981', amber: '#f59e0b', below: '#ef4444', none: 'var(--text-dimmed)' };

export function getStatus(val, targets) {
  if (!targets || (targets.upper === 0 && targets.lower === 0)) return 'none';
  if (val > targets.upper)        return 'above';
  if (val >= targets.lower)       return 'green';
  if (val >= targets.lower * 0.9) return 'amber';
  return 'below';
}

export function getPct(val, targets) {
  if (!targets || targets.upper === 0) return null;
  if (val >= targets.lower && val <= targets.upper) return 100;
  if (val > targets.upper) return Math.round((val / targets.upper) * 100);
  if (targets.lower > 0) return Math.round((val / targets.lower) * 100);
  return 0;
}

function Gauge({ label, value, targets, unit, category }) {
  const status = getStatus(value, targets);
  const color  = STATUS_COLORS[status];
  const pct    = getPct(value, targets);
  const R = 52; const cx = 70; const cy = 70;
  const startDeg = -200; const sweepDeg = 220;
  const arcPath = (pctFill) => {
    const clamp = Math.min(Math.max(pctFill, 0), 1);
    const endDeg = startDeg + sweepDeg * clamp;
    const toRad = d => (d * Math.PI) / 180;
    const x1 = cx + R * Math.cos(toRad(startDeg)); const y1 = cy + R * Math.sin(toRad(startDeg));
    const x2 = cx + R * Math.cos(toRad(endDeg));   const y2 = cy + R * Math.sin(toRad(endDeg));
    const large = sweepDeg * clamp > 180 ? 1 : 0;
    return `M ${x1} ${y1} A ${R} ${R} 0 ${large} 1 ${x2} ${y2}`;
  };
  const fillFraction = targets && targets.upper > 0 ? Math.min(value / targets.upper, 1.15) : 0;
  const lowerFrac = targets && targets.upper > 0 ? targets.lower / targets.upper : null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1, minWidth: 120 }}>
      <div style={{ position: 'relative', width: 140, height: 100 }}>
        <svg width="140" height="105" viewBox="0 0 140 105" style={{ overflow: 'visible' }}>
          <path d={arcPath(1)} fill="none" stroke="var(--gauge-track)" strokeWidth="9" strokeLinecap="round" />
          {lowerFrac && <path d={arcPath(lowerFrac)} fill="none" stroke={color === STATUS_COLORS.none ? 'var(--gauge-track)' : color} strokeWidth="9" strokeLinecap="round" strokeOpacity="0.25" />}
          <path d={arcPath(Math.min(fillFraction, 1))} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round" />
          {fillFraction > 1 && <path d={arcPath(fillFraction)} fill="none" stroke={color} strokeWidth="9" strokeLinecap="round" strokeOpacity="0.4" />}
          <text x="70" y="68" textAnchor="middle" fill={color} fontSize="17" fontWeight="700" fontFamily="Inter, sans-serif">
            {value ? Math.round(value).toLocaleString() : '—'}
          </text>
          {pct !== null && (
            <text x="70" y="83" textAnchor="middle" fill="var(--text-muted)" fontSize="10" fontFamily="Inter, sans-serif">{pct}%</text>
          )}
        </svg>
      </div>
      <div style={{ textAlign: 'center', marginTop: -4 }}>
        <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', whiteSpace: 'nowrap' }}>{label}</div>
        {targets && targets.upper > 0 && (
          <div style={{ fontSize: 10, color: 'var(--text-dimmed)', marginTop: 1 }}>
            target: {Math.round(targets.lower).toLocaleString()}–{Math.round(targets.upper).toLocaleString()}
          </div>
        )}
        <div style={{ fontSize: 10, color: 'var(--text-muted)', marginTop: 2, background: 'var(--border)', borderRadius: 4, padding: '1px 6px', display: 'inline-block' }}>{category}</div>
      </div>
    </div>
  );
}

function LoadChart({ enriched, selfPlayerId = null }) {
  const players = enriched.flatMap(p => {
    const tgt = p.targets?.HMLD;
    const value = p.metrics.HMLD ?? 0;
    if (!tgt || (tgt.upper === 0 && tgt.lower === 0)) return [];
    const isMe = !selfPlayerId || String(p.player_id) === selfPlayerId;
    if (value >= tgt.lower && value <= tgt.upper) return [];
    if (value < tgt.lower) {
      const pct = tgt.lower > 0 ? Math.round(((value - tgt.lower) / tgt.lower) * 100) : 0;
      return [{ name: p.name.split(' ')[0], pct, status: value >= tgt.lower * 0.9 ? 'amber' : 'below', blur: !isMe }];
    }
    if (value > tgt.upper) {
      const pct = tgt.upper > 0 ? Math.round(((value - tgt.upper) / tgt.upper) * 100) : 0;
      return [{ name: p.name.split(' ')[0], pct, status: 'above', blur: !isMe }];
    }
    return [];
  }).sort((a, b) => b.pct - a.pct);
  if (!players.length) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200, color: 'var(--text-dimmed)', fontSize: 13 }}>No target data available</div>
  );
  const maxAbs = Math.max(...players.map(p => Math.abs(p.pct)), 30);
  const nameW = 90; const barWpx = 110; const barMax = 100;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '4px 0' }}>
      {players.map(({ name, pct, status, blur }) => {
        const color = STATUS_COLORS[status] || STATUS_COLORS.none;
        const barW = Math.round((Math.abs(pct) / maxAbs) * barMax);
        const isOver = status === 'above';
        const showBar = status !== 'none';
        const pctLabel = status === 'none' ? '—' : `${pct > 0 ? '+' : ''}${pct}%`;
        return (
          <div key={name} style={{ display: 'flex', alignItems: 'center', gap: 8, height: 28 }}>
            <div style={{ width: nameW, fontSize: 12, color: 'var(--text-secondary)', textAlign: 'right', flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', filter: blur ? 'blur(5px)' : 'none', userSelect: blur ? 'none' : 'auto' }}>{name}</div>
            <div style={{ width: barWpx, display: 'flex', justifyContent: 'flex-end' }}>
              {showBar && !isOver && <div style={{ width: `${barW}%`, maxWidth: barWpx, height: 18, background: color, borderRadius: '3px 0 0 3px', minWidth: 2 }} />}
            </div>
            <div style={{ width: 2, height: 20, background: 'var(--border-strong)', flexShrink: 0, marginLeft: 6, marginRight: 6 }} />
            <div style={{ width: barWpx, display: 'flex', justifyContent: 'flex-start' }}>
              {showBar && isOver && <div style={{ width: `${barW}%`, maxWidth: barWpx, height: 18, background: color, borderRadius: '0 3px 3px 0', minWidth: 2 }} />}
            </div>
            <div style={{ fontSize: 12, fontWeight: 700, color, minWidth: 40, textAlign: 'right' }}>{pctLabel}</div>
          </div>
        );
      })}
      <div style={{ display: 'flex', gap: 16, marginTop: 8, paddingTop: 8, borderTop: '1px solid var(--border)', fontSize: 11, color: 'var(--text-muted)' }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 10, height: 10, background: STATUS_COLORS.below, borderRadius: 2, display: 'inline-block' }} /> Below lower target</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 10, height: 10, background: STATUS_COLORS.amber, borderRadius: 2, display: 'inline-block' }} /> Near lower target</span>
        <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}><span style={{ width: 10, height: 10, background: STATUS_COLORS.above, borderRadius: 2, display: 'inline-block' }} /> Above upper target</span>
        <span style={{ marginLeft: 'auto' }}>vs. lower/upper HMLD target</span>
      </div>
    </div>
  );
}

function PlayerRow({ player, isOdd, blurName = false }) {
  const { name, position, mdLabel, metrics, targets } = player;
  const cell = (metricKey, targetKey) => {
    const val = metrics[metricKey] ?? 0;
    const tgt = targets?.[targetKey];
    const status = getStatus(val, tgt);
    const color  = STATUS_COLORS[status];
    return (
      <td style={{ padding: '9px 12px', textAlign: 'right', fontSize: 12, color, fontWeight: 500, whiteSpace: 'nowrap' }}>
        {val ? Math.round(val).toLocaleString() : '—'}
        {tgt && tgt.upper > 0 && (
          <div style={{ fontSize: 10, color: 'var(--text-dimmed)', fontWeight: 400 }}>{Math.round(tgt.lower).toLocaleString()}–{Math.round(tgt.upper).toLocaleString()}</div>
        )}
      </td>
    );
  };
  const hmlStatus = getStatus(metrics.hmld ?? 0, targets?.HMLD);
  return (
    <tr style={{ background: isOdd ? 'var(--bg-row-alt)' : 'transparent', borderTop: '1px solid var(--border)' }}>
      <td style={{ padding: '9px 12px', whiteSpace: 'nowrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', background: STATUS_COLORS[hmlStatus], flexShrink: 0 }} />
          <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', filter: blurName ? 'blur(5px)' : 'none', userSelect: blurName ? 'none' : 'auto' }}>{name}</span>
          {player.is_estimated && (
            <span title={`Estimated (${player.estimation_method || 'method unknown'})${player.estimated_at ? `, ${new Date(player.estimated_at).toLocaleDateString()}` : ''}`}
              style={{ fontSize: 10, fontWeight: 700, color: '#92400e', background: '#fef3c7', padding: '1px 6px', borderRadius: 99, flexShrink: 0 }}>
              EST
            </span>
          )}
        </div>
      </td>
      <td style={{ padding: '9px 12px', fontSize: 11, color: 'var(--text-muted)' }}>{position || '—'}</td>
      <td style={{ padding: '9px 12px' }}>
        {mdLabel ? <span style={{ fontSize: 11, color: '#a5b4fc', fontWeight: 600, background: '#312e81', padding: '2px 7px', borderRadius: 99 }}>{mdLabel}</span>
                 : <span style={{ fontSize: 11, color: 'var(--text-dimmed)' }}>—</span>}
      </td>
      {cell('td','TD')} {cell('rd','RD')} {cell('hid','HID')} {cell('sd','SD')} {cell('sa','SA')} {cell('expl','Expl')} {cell('hmld','HMLD')}
      <td style={{ padding: '9px 12px', textAlign: 'right', fontSize: 12, color: 'var(--text-secondary)' }}>{metrics.max_speed ? `${metrics.max_speed} km/h` : '—'}</td>
      <td style={{ padding: '9px 12px', textAlign: 'right', fontSize: 12, color: 'var(--text-secondary)' }}>{metrics.minutes_played ? `${Math.round(metrics.minutes_played)}'` : '—'}</td>
    </tr>
  );
}

export default function GPSData({ playerRecord = null, user = null, mode = 'team', initialSessionId = null }) {
  const { selectedSeasons } = useSeason();
  const selfPlayerId = playerRecord?.id ? String(playerRecord.id) : null;
  const [sessions, setSessions] = useState([]);
  const [players,  setPlayers]  = useState([]);
  const [scenarios, setScenarios] = useState([]);
  const [customTemplates, setCustomTemplates] = useState([]);
  const [rpeData,  setRpeData]  = useState([]);
  const [selected, setSelected] = useUrlParam('session', '');
  const [selectedPosition, setSelectedPosition] = useUrlParam('position', 'All');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [sortKey, setSortKey] = useState('HMLD');
  const [sortDir, setSortDir] = useState('desc');
  const [rpeSortKey, setRpeSortKey] = useState('rpe_muscular');
  const [rpeSortDir, setRpeSortDir] = useState('desc');
  const [loading,  setLoading]  = useState(true);
  const [noteDraft, setNoteDraft] = useState('');
  const [editingNote, setEditingNote] = useState(false);
  const [estimateModalOpen, setEstimateModalOpen] = useState(false);
  const [savingNote, setSavingNote] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const [p, s, sc, rpe, lsc] = await Promise.all([getPlayers(), getGPS(), getScenarios(), getRPE(), getLoadScenarios()]);
        setRpeData(rpe || []);
        setPlayers(p);
        setScenarios((sc || []).map(a => ({ ...a, startDate: a.start_date?.slice(0, 10), playerId: a.player_id })));
        setCustomTemplates(lsc || []);
        const normalized = s.map(sess => ({
          ...sess,
          date:  sess.session_date?.slice(0, 10),
          title: sess.session_title,
          players: sess.players.map(pl => ({ ...pl, mdLabel: pl.md_label, playerId: pl.player_id })),
        }));
        setSessions(normalized);
        if (normalized.length) {
          // Deep-linked from elsewhere (e.g. tapping a session in the player Today timeline, or
          // a ?session=<id> URL param present at load) — land on that exact session instead of
          // always defaulting to the latest one. `selected` here is whatever the URL already
          // supplied on first render (captured once, since this effect only runs on mount).
          const requestedId = initialSessionId || selected || null;
          const requested = requestedId && normalized.find(s => String(s.id) === String(requestedId));
          const target = requested || [...normalized].sort((a, b) => new Date(b.date) - new Date(a.date))[0];
          setSelected(String(target.id));
        }
      } catch (err) { console.error('Failed to load GPS:', err); }
      finally { setLoading(false); }
    };
    load();
  }, []);

  const filteredSessions = useMemo(
    () => sessions.filter(s => {
      if (!s.date) return true;
      const season = dateToSeason(s.date);
      if (season && selectedSeasons.length > 0 && !selectedSeasons.includes(season)) return false;
      // A rehab-only day has no team players, and a normal team day has no
      // rehab players — either way, a session with nothing relevant to the
      // current mode shouldn't clutter the session dropdown.
      const relevant = mode === 'rehab' ? p => p.is_rehab : p => !p.is_rehab;
      return (s.players || []).some(relevant);
    }),
    [sessions, selectedSeasons, mode],
  );

  // Reset selected session when season filter changes
  useEffect(() => {
    if (!filteredSessions.length) { setSelected(''); return; }
    if (!filteredSessions.find(s => String(s.id) === selected)) {
      const latest = [...filteredSessions].sort((a, b) => b.date.localeCompare(a.date))[0];
      setSelected(String(latest.id));
    }
  }, [filteredSessions]);

  const session = filteredSessions.find(s => String(s.id) === selected);

  useEffect(() => {
    setNoteDraft(session?.notes || '');
    setEditingNote(false);
  }, [selected]); // eslint-disable-line react-hooks/exhaustive-deps

  const saveNote = async () => {
    if (!session) return;
    setSavingNote(true);
    try {
      const updated = await updateSessionNotes(session.id, noteDraft);
      setSessions(prev => prev.map(s => s.id === session.id ? { ...s, notes: updated.notes } : s));
      setEditingNote(false);
    } catch (err) {
      console.error('Failed to save session note:', err);
      alert('Failed to save note.');
    } finally {
      setSavingNote(false);
    }
  };

  // Built-in TARGETS only covers the hardcoded scenarios (1A-6B) — custom
  // scenario templates (created via Custom Scenario Templates) store their
  // own targets in load_scenarios and must be merged in here too, or any
  // session tagged with a custom scenario silently shows no targets.
  const allTargets = useMemo(() => {
    const custom = {};
    customTemplates.forEach(t => { custom[t.name] = t.targets; });
    return { ...TARGETS, ...custom };
  }, [customTemplates]);

  const enriched = useMemo(() => {
    if (!session) return [];
    const relevantPlayers = mode === 'rehab'
      ? session.players.filter(p => p.is_rehab)
      : session.players.filter(p => !p.is_rehab);
    return relevantPlayers.map(p => {
      const db = players.find(d => String(d.id) === String(p.player_id) || (d.name && p.player_name && d.name.toLowerCase() === p.player_name.toLowerCase()));
      const pos      = db?.position || p.position || null;
      const scenario = session.scenario;
      const mdLabel  = p.md_label || p.mdLabel;
      const rawTargets = scenario && mdLabel && pos && allTargets[scenario]?.[mdLabel]?.[pos] ? allTargets[scenario][mdLabel][pos] : null;
      const assignment = scenarios.find(sc =>
        sc.scenario === scenario &&
        (sc.playerId === 'team' || String(sc.playerId) === String(p.player_id || db?.id))
      );
      // MD (match day) is never scaled by the scenario's training intensity —
      // it's scaled by actual match minutes vs. a 90-min baseline, plus a 10%
      // warmup allowance, matching the same MD-specific factor used at CSV
      // upload time (GPSUpload.js) and in the Scenario Editor's day planner.
      const intensityFactor = mdLabel === 'MD'
        ? ((assignment?.md_minutes ?? 90) / 90) * 1.1
        : (assignment?.intensity ?? 100) / 100;
      const scaledTargets = rawTargets && intensityFactor !== 1
        ? Object.fromEntries(Object.entries(rawTargets).map(([k, { upper, lower }]) => [k, { upper: Math.round(upper * intensityFactor), lower: Math.round(lower * intensityFactor) }]))
        : rawTargets;
      // A manual day-specific override (set when planning the scenario) takes
      // full precedence over the computed/intensity-scaled targets.
      const dayOverride = assignment?.target_overrides?.[session.date]?.[pos];
      const targets = dayOverride || scaledTargets;
      return { ...p, name: p.player_name || p.name || 'Unknown', position: pos, mdLabel, targets,
        metrics: { td: p.td??0, rd: p.rd??0, hid: p.hid??0, sd: p.sd??0, sa: p.sa??0, expl: p.expl??0, hmld: p.hmld??0, HMLD: p.hmld??0, max_speed: p.max_speed??null, minutes_played: p.minutes_played??null } };
    });
  }, [session, players, scenarios, allTargets, mode]);

  const positions = useMemo(() => {
    const set = new Set(enriched.map(p => p.position).filter(Boolean));
    return ['All', ...Array.from(set)];
  }, [enriched]);

  const filteredPlayers = useMemo(() => {
    const byPos = selectedPosition && selectedPosition !== 'All' ? enriched.filter(p => p.position === selectedPosition) : [...enriched];
    if (selectedStatus === 'all') return byPos;
    return byPos.filter(p => {
      const s = getStatus(p.metrics.hmld, p.targets?.HMLD);
      if (selectedStatus === 'reached') return s === 'green';
      if (selectedStatus === 'near') return s === 'amber';
      if (selectedStatus === 'below') return s === 'below';
      if (selectedStatus === 'above') return s === 'above';
      if (selectedStatus === 'failed') return s === 'above' || s === 'below';
      return true;
    });
  }, [enriched, selectedPosition, selectedStatus]);

  const teamTotals = useMemo(() => ({
    // compute averages across filteredPlayers (per-player average)
    TD: filteredPlayers.length ? filteredPlayers.reduce((s,p)=>s+(p.metrics.td||0),0)/filteredPlayers.length : 0,
    RD: filteredPlayers.length ? filteredPlayers.reduce((s,p)=>s+(p.metrics.rd||0),0)/filteredPlayers.length : 0,
    HID: filteredPlayers.length ? filteredPlayers.reduce((s,p)=>s+(p.metrics.hid||0),0)/filteredPlayers.length : 0,
    SD: filteredPlayers.length ? filteredPlayers.reduce((s,p)=>s+(p.metrics.sd||0),0)/filteredPlayers.length : 0,
    SA: filteredPlayers.length ? filteredPlayers.reduce((s,p)=>s+(p.metrics.sa||0),0)/filteredPlayers.length : 0,
    Expl: filteredPlayers.length ? filteredPlayers.reduce((s,p)=>s+(p.metrics.expl||0),0)/filteredPlayers.length : 0,
    HMLD: filteredPlayers.length ? filteredPlayers.reduce((s,p)=>s+(p.metrics.hmld||0),0)/filteredPlayers.length : 0,
  }), [filteredPlayers]);

  const teamTargets = useMemo(() => {
    const keys = ['TD','RD','HID','SD','SA','Expl','HMLD'];
    const result = {};
    keys.forEach(k => {
      const lowers = filteredPlayers.filter(p=>p.targets?.[k]).map(p=>p.targets[k].lower);
      const uppers = filteredPlayers.filter(p=>p.targets?.[k]).map(p=>p.targets[k].upper);
      result[k] = lowers.length ? { lower: lowers.reduce((a,b)=>a+b,0)/lowers.length, upper: uppers.reduce((a,b)=>a+b,0)/uppers.length } : null;
    });
    return result;
  }, [filteredPlayers]);

  const counts = useMemo(() => ({
    green: filteredPlayers.filter(p=>getStatus(p.metrics.hmld,p.targets?.HMLD)==='green').length,
    amber: filteredPlayers.filter(p=>getStatus(p.metrics.hmld,p.targets?.HMLD)==='amber').length,
    below: filteredPlayers.filter(p=>getStatus(p.metrics.hmld,p.targets?.HMLD)==='below').length,
    above: filteredPlayers.filter(p=>getStatus(p.metrics.hmld,p.targets?.HMLD)==='above').length,
  }), [filteredPlayers]);

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'60vh', color:'var(--text-muted)', gap:12 }}>
      <Activity size={24} strokeWidth={1.5} /><span style={{ fontSize:15 }}>Loading session data…</span>
    </div>
  );
  if (!sessions.length) return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'60vh', gap:16, opacity:0.5 }}>
      <Activity size={64} strokeWidth={1} />
      <h2 style={{ fontSize:20, fontWeight:600 }}>No GPS sessions yet</h2>
      <p style={{ fontSize:14, color:'var(--text-muted)' }}>Upload a Statsports CSV in the Upload zone first.</p>
    </div>
  );
  if (!filteredSessions.length) return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'60vh', gap:16, opacity:0.5 }}>
      <Activity size={64} strokeWidth={1} />
      <h2 style={{ fontSize:20, fontWeight:600 }}>{mode === 'rehab' ? 'No rehab sessions yet' : 'No data for this season'}</h2>
      <p style={{ fontSize:14, color:'var(--text-muted)' }}>{mode === 'rehab' ? 'Sessions with a "Rehab-Full session" drill will show up here.' : 'Change the season filter in Settings to view other data.'}</p>
    </div>
  );

  const thStyle = { padding:'10px 12px', textAlign:'right', fontSize:11, fontWeight:700, color:'var(--text-muted)', whiteSpace:'nowrap', background:'var(--bg-app)' };

  return (
    <div style={{ maxWidth:1400, margin:'0 auto' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:24, flexWrap:'wrap', gap:12 }}>
        <div>
          <h1 style={{ fontSize:22, fontWeight:700 }}>{mode === 'rehab' ? 'Rehab Session Report' : 'Session Report'}</h1>
          <p style={{ color:'var(--text-muted)', fontSize:14, marginTop:4 }}>{mode === 'rehab' ? 'Individual rehab sessions with the physio, load overview with target comparisons.' : 'Team load overview with target comparisons.'}</p>
        </div>
        <div style={{ display:'flex', gap:8, alignItems:'center' }}>
          <select value={selected} onChange={e=>setSelected(e.target.value)}
            style={{ padding:'10px 16px', borderRadius:8, border:'1px solid var(--border-strong)', background:'var(--border)', color:'var(--text-primary)', fontSize:14, outline:'none', cursor:'pointer' }}>
            {[...filteredSessions].sort((a,b)=>new Date(b.date)-new Date(a.date)).map(s=>(
              <option key={s.id} value={s.id}>{s.date} — {s.title||'Session'}</option>
            ))}
          </select>
          <select value={selectedPosition} onChange={e=>setSelectedPosition(e.target.value)}
            style={{ padding:'8px 12px', borderRadius:8, border:'1px solid var(--border-strong)', background:'var(--bg-app)', color:'var(--text-primary)', fontSize:13, outline:'none', cursor:'pointer' }}>
            {positions.map(pos => (<option key={pos} value={pos}>{pos}</option>))}
          </select>
          <select value={selectedStatus} onChange={e=>setSelectedStatus(e.target.value)}
            style={{ padding:'8px 12px', borderRadius:8, border:'1px solid var(--border-strong)', background:'var(--bg-app)', color:'var(--text-primary)', fontSize:13, outline:'none', cursor:'pointer' }}>
            <option value="all">All statuses</option>
            <option value="reached">On target</option>
            <option value="near">Near target</option>
            <option value="below">Under target</option>
            <option value="above">Over target</option>
            <option value="failed">Off target</option>
          </select>
        </div>
      </div>

      {session && (<>
        <div style={{ display:'flex', gap:12, marginBottom:24, flexWrap:'wrap', alignItems:'stretch' }}>
          <div style={{ background:'var(--border)', borderRadius:12, padding:'16px 20px', border:'1px solid var(--border-strong)', flex:1, minWidth:220 }}>
            <div style={{ fontSize:18, fontWeight:700 }}>{session.title||'Session'}</div>
            <div style={{ fontSize:13, color:'var(--text-muted)', marginTop:2 }}>{session.date} · {enriched.length} players</div>
            {enriched[0]?.mdLabel && (
              <div style={{ marginTop:8, display:'inline-block', padding:'3px 10px', borderRadius:99, background:'#312e81', color:'#a5b4fc', fontSize:12, fontWeight:600 }}>
                {enriched[0].mdLabel} · Scenario {session.scenario}
              </div>
            )}
          </div>
          {[
            {label:'On target',    val:counts.green, key:'reached', color:'#10b981', rgba:'16,185,129'},
            {label:'Near target',  val:counts.amber, key:'near',    color:'#f59e0b', rgba:'245,158,11'},
            {label:'Under target', val:counts.below, key:'below',   color:'#ef4444', rgba:'239,68,68'},
            {label:'Over target',  val:counts.above, key:'above',   color:'#7c3aed', rgba:'124,58,237'},
          ].map(({label,val,key,color,rgba})=> {
            const active = selectedStatus === key;
            return (
              <div key={label}
                onClick={() => setSelectedStatus(active ? 'all' : key)}
                style={{
                  background: active ? `rgba(${rgba},0.15)` : `rgba(${rgba},0.07)`,
                  borderRadius:12,
                  padding:'16px 20px',
                  border:`1px solid rgba(${rgba},${active ? '0.5' : '0.2'})`,
                  textAlign:'center',
                  minWidth:100,
                  display:'flex',
                  flexDirection:'column',
                  justifyContent:'center',
                  cursor:'pointer',
                  transition:'all 0.15s',
                }}>
                <div style={{ fontSize:30, fontWeight:800, color }}>{val}</div>
                <div style={{ fontSize:12, color, opacity:0.75, marginTop:2 }}>{label}</div>
              </div>
            );
          })}
        </div>

        {!playerRecord && session && ['staff', 'admin'].includes(user?.role) && (
          <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:12 }}>
            <button onClick={() => setEstimateModalOpen(true)} style={{ padding:'8px 14px', borderRadius:8, border:'1px solid var(--border-strong)', background:'none', color:'var(--text-primary)', cursor:'pointer', fontSize:13, fontWeight:600 }}>
              Estimate missed GPS data
            </button>
          </div>
        )}
        {estimateModalOpen && session && (
          <EstimateModal
            sessionId={session.id}
            user={user}
            onClose={() => setEstimateModalOpen(false)}
            onCommitted={() => getGPS().then(setSessions)}
          />
        )}

        {!playerRecord && (
          <div style={{ background:'var(--border)', borderRadius:12, padding:'16px 20px', border:'1px solid var(--border-strong)', marginBottom:24 }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom: (editingNote || noteDraft) ? 10 : 0 }}>
              <div style={{ fontSize:13, fontWeight:600, color:'var(--text-secondary)', display:'flex', alignItems:'center', gap:6 }}>
                <FileText size={14} /> Trainer's notes
              </div>
              {user?.isAdmin && !editingNote && (
                <button onClick={() => setEditingNote(true)} style={{ background:'none', border:'none', color:'var(--text-muted)', cursor:'pointer', display:'flex', alignItems:'center', gap:4, fontSize:12, padding:0 }}>
                  <Pencil size={12} /> {noteDraft ? 'Edit' : 'Add note'}
                </button>
              )}
            </div>
            {editingNote ? (
              <div>
                <textarea
                  value={noteDraft}
                  onChange={e => setNoteDraft(e.target.value)}
                  placeholder="Write a review of this training session for the staff to see…"
                  style={{ width:'100%', minHeight:90, padding:'10px 12px', borderRadius:8, border:'1px solid var(--border-strong)', background:'var(--bg-app)', color:'var(--text-primary)', fontSize:13, fontFamily:'inherit', resize:'vertical', boxSizing:'border-box' }}
                />
                <div style={{ display:'flex', justifyContent:'flex-end', gap:8, marginTop:8 }}>
                  <button onClick={() => { setNoteDraft(session.notes || ''); setEditingNote(false); }} style={{ padding:'6px 12px', borderRadius:8, border:'1px solid var(--border-strong)', background:'none', color:'var(--text-secondary)', cursor:'pointer', fontSize:12 }}>Cancel</button>
                  <button onClick={saveNote} disabled={savingNote} style={{ padding:'6px 12px', borderRadius:8, border:'none', background:'#3b82f6', color:'#fff', cursor:'pointer', fontSize:12, fontWeight:600 }}>{savingNote ? 'Saving…' : 'Save note'}</button>
                </div>
              </div>
            ) : noteDraft ? (
              <div style={{ fontSize:13, color:'var(--text-primary)', whiteSpace:'pre-wrap', lineHeight:1.5 }}>{noteDraft}</div>
            ) : (
              <div style={{ fontSize:13, color:'var(--text-dimmed)', fontStyle:'italic' }}>No notes for this session yet.</div>
            )}
          </div>
        )}

          <div style={{ display:'grid', gridTemplateColumns:'1fr 420px', gap:16, marginBottom:24, alignItems:'start' }}>
          <div style={{ background:'var(--border)', borderRadius:12, padding:'20px 16px', border:'1px solid var(--border-strong)' }}>
            <div style={{ fontSize:13, fontWeight:600, color:'var(--text-secondary)', marginBottom:16 }}>
              <Users size={14} style={{ verticalAlign:'middle', marginRight:6 }} />Team totals — entire session
            </div>
            <div style={{ display:'flex', flexWrap:'wrap', gap:8, justifyContent:'space-around' }}>
              {GAUGE_METRICS.map(m=><Gauge key={m.key} label={m.label} value={teamTotals[m.key]} targets={teamTargets[m.key]} unit={m.unit} category={m.category} />)}
            </div>
            <div style={{ marginTop:20, borderTop:'1px solid var(--border-strong)', paddingTop:16, display:'flex', alignItems:'center', gap:16 }}>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:11, color:'var(--text-muted)', marginBottom:4 }}>Total team HMLD</div>
                <div style={{ fontSize:26, fontWeight:800, color:STATUS_COLORS[getStatus(teamTotals.HMLD,teamTargets.HMLD)] }}>
                  {Math.round(teamTotals.HMLD).toLocaleString()} <span style={{ fontSize:14, fontWeight:400, color:'var(--text-muted)' }}>m</span>
                </div>
                {teamTargets.HMLD && <div style={{ fontSize:11, color:'var(--text-dimmed)', marginTop:2 }}>target {Math.round(teamTargets.HMLD.lower).toLocaleString()}–{Math.round(teamTargets.HMLD.upper).toLocaleString()} m</div>}
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:8 }}>
                {[
                  {label:'Avg HMLD / player', val:filteredPlayers.length?Math.round(teamTotals.HMLD).toLocaleString():'—', unit:'m'},
                  {label:'Avg max speed', val:filteredPlayers.filter(p=>p.metrics.max_speed).length?(filteredPlayers.reduce((s,p)=>s+(p.metrics.max_speed||0),0)/filteredPlayers.filter(p=>p.metrics.max_speed).length).toFixed(1):'—', unit:'km/h'},
                  {label:'Players tracked', val:filteredPlayers.length, unit:''},
                ].map(({label,val,unit})=>(
                  <div key={label} style={{ background:'var(--bg-app)', borderRadius:8, padding:'10px 14px', textAlign:'center' }}>
                    <div style={{ fontSize:10, color:'var(--text-muted)', marginBottom:4 }}>{label}</div>
                    <div style={{ fontSize:16, fontWeight:700, color:'var(--text-primary)' }}>{val}<span style={{ fontSize:11, color:'var(--text-muted)' }}>{unit?` ${unit}`:''}</span></div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div style={{ background:'var(--border)', borderRadius:12, padding:'20px 16px', border:'1px solid var(--border-strong)' }}>
            <div style={{ fontSize:13, fontWeight:600, color:'var(--text-secondary)', marginBottom:16 }}>
              <TrendingUp size={14} style={{ verticalAlign:'middle', marginRight:6 }} />Over / Underloaded players
            </div>
            <LoadChart enriched={filteredPlayers} selfPlayerId={selfPlayerId} />
          </div>
        </div>

        <div style={{ background:'var(--border)', borderRadius:12, border:'1px solid var(--border-strong)', overflow:'hidden' }}>
          <div style={{ padding:'14px 20px', borderBottom:'1px solid var(--border-strong)', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <span style={{ fontWeight:700, fontSize:15 }}>Individual breakdown</span>
            <span style={{ fontSize:12, color:'var(--text-dimmed)' }}>Color = vs. HMLD target · Range shown beneath value</span>
          </div>
            <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr>
                  <th style={{ ...thStyle, textAlign:'left', cursor:'pointer' }} onClick={()=>{ if(sortKey==='name') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('name'); setSortDir('asc'); } }}>Player {sortKey==='name'?(sortDir==='asc'?'▲':'▼'):''}</th>
                  <th style={{ ...thStyle, textAlign:'left', cursor:'pointer' }} onClick={()=>{ if(sortKey==='position') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('position'); setSortDir('asc'); } }}>Pos {sortKey==='position'?(sortDir==='asc'?'▲':'▼'):''}</th>
                  <th style={{ ...thStyle, textAlign:'left', cursor:'pointer' }} onClick={()=>{ if(sortKey==='mdLabel') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('mdLabel'); setSortDir('asc'); } }}>MD {sortKey==='mdLabel'?(sortDir==='asc'?'▲':'▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='TD') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('TD'); setSortDir('desc'); } }}>TD (m){sortKey==='TD'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='RD') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('RD'); setSortDir('desc'); } }}>RD &gt;14.4{sortKey==='RD'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='HID') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('HID'); setSortDir('desc'); } }}>HID &gt;19.8{sortKey==='HID'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='SD') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('SD'); setSortDir('desc'); } }}>Sprint &gt;25.2{sortKey==='SD'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='SA') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('SA'); setSortDir('desc'); } }}>Short Act.{sortKey==='SA'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='Expl') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('Expl'); setSortDir('desc'); } }}>Expl. Dist.{sortKey==='Expl'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='HMLD') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('HMLD'); setSortDir('desc'); } }}>HMLD{sortKey==='HMLD'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='max_speed') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('max_speed'); setSortDir('desc'); } }}>Max Spd{sortKey==='max_speed'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                  <th style={{...thStyle,cursor:'pointer'}} onClick={()=>{ if(sortKey==='minutes_played') setSortDir(sortDir==='desc'?'asc':'desc'); else { setSortKey('minutes_played'); setSortDir('desc'); } }}>Mins{sortKey==='minutes_played'?(sortDir==='asc'?' ▲':' ▼'):''}</th>
                </tr>
              </thead>
              <tbody>
                {(() => {
                  const list = [...filteredPlayers];
                  const k = sortKey;
                  const dir = sortDir === 'asc' ? 1 : -1;
                  list.sort((a,b)=>{
                    const get = (item,key)=>{
                      if (!item) return null;
                      if (key==='name' || key==='position' || key==='mdLabel') return String(item[key]||'').toLowerCase();
                      return (item.metrics && (item.metrics[key.toLowerCase()] ?? item.metrics[key] ?? item[key])) ?? 0;
                    };
                    const va = get(a,k); const vb = get(b,k);
                    if (typeof va === 'string' && typeof vb === 'string') return va.localeCompare(vb) * dir;
                    return (Number(va) - Number(vb)) * dir;
                  });
                  return list.map((p,i)=>{
                    const blurName = !!selfPlayerId && String(p.player_id) !== selfPlayerId && p.name?.toLowerCase() !== playerRecord?.name?.toLowerCase();
                    return <PlayerRow key={p.player_id||p.name} player={p} isOdd={i%2!==0} blurName={blurName} />;
                  });
                })()}
              </tbody>
              <tfoot>
                <tr style={{ background:'var(--bg-app)', borderTop:'2px solid var(--border-strong)' }}>
                  <td colSpan={3} style={{ padding:'10px 12px', fontSize:12, fontWeight:700, color:'var(--text-secondary)' }}>Team total</td>
                  {[teamTotals.TD,teamTotals.RD,teamTotals.HID,teamTotals.SD,teamTotals.SA,teamTotals.Expl,teamTotals.HMLD].map((val,i)=>(
                    <td key={i} style={{ padding:'10px 12px', textAlign:'right', fontSize:13, fontWeight:700, color:'var(--text-primary)' }}>{val?Math.round(val).toLocaleString():'—'}</td>
                  ))}
                  <td colSpan={2} />
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      {/* ── Session RPE ── */}
      {(() => {
        if (!session) return null;
        const sessionDate = session.date;
        const sessionRpe = rpeData.filter(r => (r.date || '').slice(0, 10) === sessionDate);
        const activePlayers = players.filter(p => p.active !== false);

        // Match RPE entry to player (by player_id or name)
        const rpeForPlayer = (p) => sessionRpe.find(r =>
          String(r.player_id) === String(p.id) ||
          (r.player_name && p.name && r.player_name.toLowerCase() === p.name.toLowerCase())
        );

        const submitted = activePlayers.filter(p => rpeForPlayer(p));

        const avgM = submitted.length ? submitted.reduce((s, p) => s + Number(rpeForPlayer(p)?.rpe_muscular || 0), 0) / submitted.length : null;
        const avgC = submitted.length ? submitted.reduce((s, p) => s + Number(rpeForPlayer(p)?.rpe_cardiovascular || 0), 0) / submitted.length : null;

        const rpeColor = v => v == null ? 'var(--text-dimmed)' : rpeValueColor(v);
        const rpeBarColor = rpeColor;

        const handleRpeSort = (key) => {
          if (rpeSortKey === key) setRpeSortDir(d => d === 'asc' ? 'desc' : 'asc');
          else { setRpeSortKey(key); setRpeSortDir(key === 'name' ? 'asc' : 'desc'); }
        };
        const rpeSortIndicator = key => rpeSortKey === key ? (rpeSortDir === 'asc' ? ' ▲' : ' ▼') : '';

        // Every active player is listed, including those who haven't
        // submitted yet (rpe: null), so gaps are visible at a glance.
        const rows = [...activePlayers]
          .map(p => ({ player: p, rpe: rpeForPlayer(p) }))
          .sort((a, b) => {
            const dir = rpeSortDir === 'asc' ? 1 : -1;
            if (rpeSortKey === 'name') return (a.player.name || '').localeCompare(b.player.name || '') * dir;
            const av = a.rpe ? Number(a.rpe[rpeSortKey]) : null;
            const bv = b.rpe ? Number(b.rpe[rpeSortKey]) : null;
            if (av == null && bv == null) return 0;
            if (av == null) return 1;
            if (bv == null) return -1;
            return (av - bv) * dir;
          });

        return (
          <div style={{ background:'var(--bg-card)', border:'1px solid var(--border)', borderRadius:14, marginTop:20, overflow:'hidden' }}>
            {/* Header + summary stats */}
            <div style={{ padding:'13px 18px', borderBottom:'1px solid var(--border)', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:12 }}>
              <span style={{ fontSize:'0.86rem', fontWeight:700, color:'var(--text-primary)' }}>Session RPE</span>
              <div style={{ display:'flex', gap:24, alignItems:'center', flexWrap:'wrap' }}>
                {avgM != null && (
                  <div style={{ textAlign:'center' }}>
                    <div style={{ fontSize:'0.65rem', fontWeight:600, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.07em', marginBottom:2 }}>Avg Muscular</div>
                    <div style={{ fontSize:'1.1rem', fontWeight:700, color:rpeColor(Math.round(avgM)) }}>{avgM.toFixed(1)}</div>
                    <div style={{ fontSize:'0.7rem', color:rpeColor(Math.round(avgM)), marginTop:2 }}>{rpeAssessment(Math.round(avgM))}</div>
                  </div>
                )}
                {avgC != null && (
                  <div style={{ textAlign:'center' }}>
                    <div style={{ fontSize:'0.65rem', fontWeight:600, color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.07em', marginBottom:2 }}>Avg Cardiovascular</div>
                    <div style={{ fontSize:'1.1rem', fontWeight:700, color:rpeColor(Math.round(avgC)) }}>{avgC.toFixed(1)}</div>
                    <div style={{ fontSize:'0.7rem', color:rpeColor(Math.round(avgC)), marginTop:2 }}>{rpeAssessment(Math.round(avgC))}</div>
                  </div>
                )}
                <div style={{ fontSize:'0.78rem', color:'var(--text-muted)', borderLeft:'1px solid var(--border)', paddingLeft:16 }}>
                  <span style={{ fontWeight:600, color:'var(--text-primary)' }}>{submitted.length}</span> of {activePlayers.length} players submitted
                </div>
              </div>
            </div>
            {/* Per-player rows */}
            {rows.length === 0 && (
              <div style={{ padding:'20px 18px', color:'var(--text-dimmed)', fontSize:'0.83rem', fontStyle:'italic' }}>
                No active players found.
              </div>
            )}
            {rows.length > 0 && (
              <div style={{ padding:'8px 18px 14px' }}>
                {/* Column headers */}
                <div style={{ display:'grid', gridTemplateColumns:'180px 1fr 1fr', gap:16, padding:'0 0 6px', marginBottom:2, borderBottom:'1px solid var(--border)' }}>
                  <span style={{ fontSize:'0.65rem', fontWeight:600, color:'var(--text-dimmed)', textTransform:'uppercase', letterSpacing:'0.07em', cursor:'pointer', userSelect:'none' }} onClick={() => handleRpeSort('name')}>Player{rpeSortIndicator('name')}</span>
                  <span style={{ fontSize:'0.65rem', fontWeight:600, color:'var(--text-dimmed)', textTransform:'uppercase', letterSpacing:'0.07em', cursor:'pointer', userSelect:'none' }} onClick={() => handleRpeSort('rpe_muscular')}>Muscular RPE{rpeSortIndicator('rpe_muscular')}</span>
                  <span style={{ fontSize:'0.65rem', fontWeight:600, color:'var(--text-dimmed)', textTransform:'uppercase', letterSpacing:'0.07em', cursor:'pointer', userSelect:'none' }} onClick={() => handleRpeSort('rpe_cardiovascular')}>Cardiovascular RPE{rpeSortIndicator('rpe_cardiovascular')}</span>
                </div>
                {rows.map(({ player, rpe }, i) => {
                  const m = Number(rpe?.rpe_muscular) || null;
                  const c = Number(rpe?.rpe_cardiovascular) || null;
                  return (
                    <div key={player.id} style={{ display:'grid', gridTemplateColumns:'180px 1fr 1fr', gap:16, alignItems:'center', padding:'7px 0', borderBottom: i < rows.length - 1 ? '1px solid var(--border)' : 'none' }}>
                      <div style={{ fontSize:'0.82rem', fontWeight:500, color:'var(--text-primary)', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', filter: (selfPlayerId && String(player.id) !== selfPlayerId) ? 'blur(5px)' : 'none', userSelect: (selfPlayerId && String(player.id) !== selfPlayerId) ? 'none' : 'auto' }}>{player.name}</div>
                      {/* Muscular bar */}
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{ flex:1, height:8, borderRadius:99, background:'var(--bg-app)', overflow:'hidden' }}>
                          <div style={{ height:'100%', width:`${(m / 10) * 100}%`, background:rpeBarColor(m), borderRadius:99, transition:'width 0.3s' }} />
                        </div>
                        <span style={{ fontSize:'0.78rem', fontWeight:700, color:rpeColor(m), minWidth:18, textAlign:'right' }}>{m ?? '—'}</span>
                      </div>
                      {/* Cardiovascular bar */}
                      <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                        <div style={{ flex:1, height:8, borderRadius:99, background:'var(--bg-app)', overflow:'hidden' }}>
                          <div style={{ height:'100%', width:`${(c / 10) * 100}%`, background:rpeBarColor(c), borderRadius:99, transition:'width 0.3s' }} />
                        </div>
                        <span style={{ fontSize:'0.78rem', fontWeight:700, color:rpeColor(c), minWidth:18, textAlign:'right' }}>{c ?? '—'}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })()}
      </>)}
    </div>
  );
}
